module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_02-7a539bea52abbe6c49da7145d6701dc9.webp";